<template>
  <div class="popup">
    <div
      class="popup-background"
      @click="close"
    />
    <div class="popup-content">
      <div
        class="close"
        @click="close"
      >
        <IconsClose />
      </div>
      <div class="flex-column">
        <div v-if="title">
          <p class="bold has-text-size-18 mr-3 mb-1">
            {{ title }}
          </p>
        </div>
        <div class="scroll-container">
          <div class="scroll-content">
            <slot />
          </div>
        </div>
        <div
          v-if="okButtonText"
          class="flex-column mt-1"
        >
          <button
            class="btn btnL"
            @click="close"
          >
            {{ okButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  width: String,
  title: String,
  okButtonText: String,
});

const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};
</script>

<style scoped lang="scss">
.popup {
  position: fixed;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;

  &-background {
    background: rgba(18, 18, 18, 0.4);
    position: fixed;
    inset: 0;
    z-index: 10;
  }

  &-content {
    position: relative;
    width: v-bind(width);
    max-width: 95%;
    background: white;
    padding: 48px 24px 24px 24px;
    border-radius: 8px;
    z-index: 11;
    max-height: 95%;
    display: flex;

    .scroll-container {
      position: relative;
      overflow: auto;

      .scroll-content {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.close {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;

  svg {
    display: block;
    margin: 0;
  }
}

@media only screen and (max-width: 792px) {
  .popup {
    &-content {
      padding: 32px 16px 16px 16px;
      margin: 76px 16px 16px 16px;
      max-height: calc(100% - 75px);

      & > div {
        overflow: auto;
      }
    }
  }
}
</style>
